import { getXPartner } from "@/app/utils/helper";

export const getUserEmail = async () => {
    try {
        const url = `${process.env.API_BASE_URL}/users/getUserEmail`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-partner": getXPartner()
            },
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching user email:", err);
        throw err;
    }
};

export const getThirdPartyUserData = async () => {
    try {
        const url = `${process.env.API_BASE_URL}/users/thirdpartyData`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-partner": getXPartner(),
            },
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching third-party user data:", err);
        throw err;
    }
};

export const postUserCheckpointsStatus = async (
    email: string,
    pan: string,
    checkpoints: string[],
    path: string,
    PRODUCT_CODE: string,
    productType?: string,
) => {
    try {
        const payload = {
            email,
            pan,
            checkpoints: checkpoints,
            path: path ?? "obUserTxn",
            product: PRODUCT_CODE,
            productType: productType,
            skipCache: true,
        };

        const response = await fetch(`${process.env.API_BASE_URL}/stats/checkpoints/status`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-product": "orobonds:default",
                "X-partner": getXPartner(),
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error posting user checkpoints status:", err);
        throw err;
    }
};

export const getPans = async () => {
    try {
        const url = `${process.env.API_BASE_URL}/orobonds/users/getPans`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "X-product": "orobonds:default",
                "X-partner": getXPartner(),
            },
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching PANs:", err);
        throw err;
    }
};
